import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	applyingUimErrorFlagTitle: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.applying-uim-error-flag-title',
		defaultMessage: 'There was an error with applying UI modifications.',
		description: 'Title displayed on the flag when applying UI modifications failed',
	},
	applyingUimErrorFlagDescription: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.applying-uim-error-flag-description',
		defaultMessage: 'We encountered an error while applying changes made by UI modifications apps.',
		description: 'Description displayed on the flag when applying UI modifications failed',
	},
	genericUimErrorFlagDescription: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.generic-uim-error-flag-description',
		defaultMessage: 'We encountered an error while applying changes made by UI modifications apps.',
		description: 'Description displayed on the flag while applying UI modifications failed',
	},
	loadingUimErrorFlagTitle: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.loading-uim-error-flag-title',
		defaultMessage: 'We couldn’t load UI modifications.',
		description: 'Title displayed on the flag while loading UI modifications failed',
	},
	missingScopesUimErrorFlagTitle: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.missing-scopes-uim-error-flag-title',
		defaultMessage: 'Missing scopes for UI modifications apps',
		description:
			'Title displayed on the flag while applying UI modifications failed due to an missing scopes error',
	},
	missingScopesUimErrorFlagDescription: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.missing-scopes-uim-error-flag-description',
		defaultMessage:
			'We couldn’t load some of the UI modifications apps for this page, because they don’t have required scopes.',
		description:
			'Description displayed on the flag while applying UI modifications failed due to an missing scopes error',
	},
	perFieldHookErrorFlagTitle: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.per-field-hook-error-flag-title',
		defaultMessage: 'We had some issues with applying UI modifications.',
		description:
			'Title displayed on the flag while saving UI modifications value to a field failed',
	},
	perFieldHookErrorFlagDescription: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.per-field-hook-error-flag-description',
		defaultMessage: 'We encountered an error while applying UI modifications to “{fieldName}”.',
		description:
			'Description displayed on the flag while saving UI modifications value to a field failed',
	},
	multiAppConflictUimErrorFlagTitle: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.multi-app-conflict-uim-error-flag-title',
		defaultMessage: 'Multiple UI modifications apps conflict.',
		description:
			'Title displayed on the flag when multiple UI modifications apps tried to use the same method on the same field.',
	},
	multiAppConflictErrorFlagDescription: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.multi-app-conflict-error-flag-description',
		defaultMessage:
			'Multiple UI modifications apps tried to call the same API method on the same field. All customizations have been dismissed.',
		description:
			'Description displayed on the flag when multiple UI modifications apps tried to modify the same property of the same field.',
	},
	bufferTimeoutFlagTitle: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.buffer-timeout-flag-title',
		defaultMessage: 'Some of the UI modifications apps have timed out.',
		description:
			'Title displayed on the flag when one or more UI modifications apps have been processing too long.',
	},
	bufferTimeoutFlagDescription: {
		id: 'ui-modifications-view-issue-view.entry-point.error-flags.hooks.use-error-flag-config.buffer-timeout-flag-description',
		defaultMessage: 'Some apps did not apply changes before the timeout and have been dismissed.',
		description:
			'An error that gets displayed when one or more UI modifications apps have been processing too long.',
	},
});
